module.exports = __webpack_public_path__ + "./docs/img/web.9232e529b8f6ce7a073c68855940d81c.svg";